@if (!courseDialogData) {
  <div class="campus_rightpanel">
    <div class="manage_course">
      <div class="institution_details">
        <app-page-header pageName="Manage course & instance"></app-page-header>
        <app-course-listing-table-details></app-course-listing-table-details>
      </div>
    </div>
  </div>
} @else {
  <mat-dialog-content>
    <div class="entry_requirement_popup">
      <div class="entry_require_popup">
        <div class="entry_require_title">Course
          <a class="material-icons" mat-dialog-close>close</a>
        </div>
        <!-- <a class="back_btn" *ngIf="showBackOption" (click)="openErDetailsPopup()"><span class="material-icons">chevron_left</span>BACK</a> -->
        <p class="course_content">Click on a instance to view the attached course instance(s)</p>
        <app-course-listing-table-details [courseErDialogData]="courseDialogData" (closeCourseListingPopup)="closeCourseListingPopup($event)"></app-course-listing-table-details>
      </div>
    </div>
  </mat-dialog-content>
}
